<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits } from 'vue';
import BotaoTextoBase from '@/components/v2/base/BotaoTextoBase/BotaoTextoBase.vue';
import ChipBase from '@/components/v2/base/ChipBase/ChipBase.vue';
import ChipUsuario from '@/components/v2/compostos/ChipUsuario/ChipUsuario.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    dado: {
        type: Object,
        default: () => ({})
    }
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'fecharModal'
]);

/*==================================================================*/
/*============== EMIT FECHAR MODAL =================================*/
/*==================================================================*/

function emitFecharModal(){
    emits('fecharModal');
}

</script>

<template>

    <div class="c-navegacao">
        
        <div class="c-grid">

            <div class="c-grid__titulo">

                <ChipBase class="c-chip-titulo"
                    icon="mdi-invoice-list-outline"
                    backgroundColor="transparent"
                    textColor="#ffffff"
                    fontSize="28px"
                    size="36px"
                >
                    <slot name="navegacao-titulo"></slot>
                </ChipBase>

            </div>

            <div class="c-grid__botao-fechar">

                <BotaoTextoBase
                    color="#ff5252"
                    :disabled="props.disabled"
                    :click="emitFecharModal"
                >
                    Fechar
                </BotaoTextoBase>

            </div>

            <div class="c-grid__usuario">

                <ChipUsuario class="c-chip-usuario"
                    backgroundColor="#e0e0e0"
                    textColor="#353535"
                    size="36px"
                ></ChipUsuario>

            </div>

            <div class="c-grid__botoes-extras">

                <slot name="navegacao-botoes"></slot>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-navegacao {
    position: sticky;
    z-index: 1;
    top: 0;
    padding: 6px 16px !important;
    margin: 0px 0 4px 0px !important;
    border-color: #230bc1 !important;
    background-color: #230bc1 !important;
    color: #FFFFFF;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.c-grid{
    display: grid;
    grid-template-columns: max-content max-content 1fr 1fr;
    grid-auto-rows: max-content;
    grid-template-areas: 
    "titulo titulo titulo titulo"
    "fechar usuario botoesExtras botoesExtras";
    gap: 10px;
}

.c-grid__titulo{
    display: flex;
    justify-content: center;
    grid-area: titulo;
}

.c-grid__botao-fechar{
    grid-area: fechar;
    display: flex;
    align-items: center;
    gap: 10px;
}

.c-grid__botoes-fechar-extras{
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.c-grid__usuario{
    grid-area: usuario;
}

.c-grid__botoes-extras{
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    grid-area: botoesExtras;
}

@media (max-width: 1024px) {

    .c-grid{
        display: grid;
        grid-template-columns: max-content max-content 1fr;
        grid-auto-rows: max-content;
        grid-template-areas: 
            "titulo titulo titulo"
            "fechar usuario usuario"
            "botoesExtras botoesExtras botoesExtras";
        gap: 10px;
    }

    .c-grid__botoes-extras{
        justify-content: flex-start;
    }

}

@media (max-width: 500px) {

    .c-grid{
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: max-content;
        grid-template-areas: 
            "titulo"
            "usuario"
            "fechar"
            "botoesExtras";
        gap: 10px;
    }

    .c-grid__botoes-extras{
        justify-content: flex-start;
    }

    .c-chip-usuario{
        display: grid;
        justify-content: center;
    }

}

</style>
